export const MLB = "MLB";
export const NFL = "NFL";
export const NHL = "NHL";
export const NBA = "NBA";
export const ALL = "All";
export const AVAILABLE_SPORTS = [MLB, NFL, NHL, NBA];
